import { ItemOption } from '@decisiv/ui-components/lib/atoms/OptionsList/types';

type ManagedTeamsData = NonNullable<
  NonNullable<
    NonNullable<
      CurrentUserManagedTeamsQuery['currentUserProfile']['user']
    >['managedSentinelTeams']
  >
>;

export const buildOemAndTeamOptions = (data: ManagedTeamsData) => {
  const segmentsMap = new Map<string, ItemOption>();
  const teamsBySegment = new Map<string, Map<string, ItemOption>>();

  data.forEach((team) => {
    const segment = team.oemSegment;

    if (!segment) return;

    if (!segmentsMap.has(segment.id)) {
      segmentsMap.set(segment.id, {
        id: segment.id,
        label: segment.name,
        value: segment.id,
      });
    }

    if (!teamsBySegment.has(segment.id)) {
      teamsBySegment.set(segment.id, new Map());
    }

    const teamMap = teamsBySegment.get(segment.id);

    /* istanbul ignore next -- @preserve -- just narrowing down the type */
    if (!teamMap) return;

    if (!teamMap.has(team.id)) {
      teamMap.set(team.id, {
        id: team.id,
        label: team.name,
        value: team.id,
      });
    }
  });

  return [
    Array.from(segmentsMap.values()),
    new Map(
      Array.from(teamsBySegment.entries()).map(([segmentId, teamMap]) => [
        segmentId,
        Array.from(teamMap.values()),
      ]),
    ),
  ] as const;
};
